import React, { useEffect } from 'react';
import { MerchantInfo } from 'store/termsAndConditions/termsAndConditionsSlice';
import {
  TermsTextWrapper,
  TermsPlainTextWrapper,
  TermsSubTitle,
  TermsPlainText,
  Footer,
  IndentedParagraph
} from 'pages/styles';
import moment from 'moment/moment';

export const TermsAndConditionsDE = (merchantInfo: MerchantInfo) => {
  const {
    merchantName,
    cityOfBusinessRegistration,
    address1,
    address2,
    city,
    country,
    zip,
    commercialRegisterNumber,
    email,
    pointThreshhold,
    rewardAmount,
    activationDate
  } = merchantInfo;
  const companyAddress = [address1, address2, city, country, zip].filter(item => !!item).join(', ');
  const formattedActivationDate = moment(activationDate).format('DD.MM.YYYY');

  const title: string = 'BEDINGUNGEN FÜR DIE TEILNAHME AM LOYALTY PROGRAMM';

  useEffect(() => {
    document.title = title;
  }, []);

  return (
    <TermsTextWrapper>
      <h2>{title}</h2>
      <TermsPlainTextWrapper>
        <TermsSubTitle>1. TEILNAHME AM LOYALTY PROGRAMM</TermsSubTitle>

        <IndentedParagraph>
          1.1. Das Unternehmen {merchantName || '[Firmenname]'} mit Sitz in {companyAddress || '[Firmenadresse]'},
          (ggf.: eingetragen im Handelsregister bei {cityOfBusinessRegistration || '[Sitz-des-Handelsregisters]'} unter{' '}
          {commercialRegisterNumber || '[Handelsregisternummer]'}), E-Mail {email || '[Firmen-E-Mail-Adresse]'}{' '}
          (&quot;Händler&quot;) betreibt ein Loyalty Programm (&quot;Loyalty Programm&quot;). Das Loyalty Programm
          ermöglicht es den Kunden des Händlers, bei der Zahlung mit der Karte Treuepunkte zu sammeln und anschließend
          die den gesammelten Treuepunkten entsprechende Prämie in der in diesen Geschäftsbedingungen beschriebenen
          Weise einzulösen. Die Teilnahme am Loyalty Programm unterliegt diesen Bedingungen (&quot;Bedingungen&quot;).
        </IndentedParagraph>
        <IndentedParagraph>
          1.2. Jede natürliche Person, die das 18. Lebensjahr vollendet hat, kann Teilnehmer des Loyalty Programms
          werden. Mit der Annahme dieser Allgemeinen Geschäftsbedingungen bestätigt die Person, die am Loyalty Programm
          teilnehmen möchte, dass sie mindestens 18 Jahre alt ist.
        </IndentedParagraph>
        <IndentedParagraph>
          1.3. Der Händler hat diese Allgemeinen Geschäftsbedingungen und Informationen über das Loyalty Programm,
          einschließlich der Datenschutzerklärung, in seinen Geschäftsräumen ausgehängt und stellt sie dem Kunden auf
          Anfrage zur Einsichtnahme zur Verfügung.
        </IndentedParagraph>
        <IndentedParagraph>
          1.4. Um am Loyalty Programm teilzunehmen, muss der Kunde den Händler mit einer von VISA oder Mastercard
          unterstützten Kredit- oder Debitkarte, die in Deutschland für ein Konto für eine nicht gewerbliche Person
          ausgegeben wurde, oder über eine andere Bankkarte (Giro- oder Debitkarte), die das elektronische
          Lastschriftverfahren (&quot;ELV&quot;) unterstützt, bezahlen, sofern das Konto von einer nicht gewerblichen
          Person geführt wird. Wenn die Karte keinem Kundenkonto im Rahmen des Loyalty Programms zugeordnet ist, fordert
          das Zahlungsterminal den Kunden auf, am Loyalty Programm teilzunehmen.
        </IndentedParagraph>
        <IndentedParagraph>
          1.5. Im Rahmen der Einladung zur Teilnahme am Loyalty Programm werden dem Kunden die folgenden Allgemeinen
          Geschäftsbedingungen, denen der Kunde zustimmen muss, um am Loyalty Programm teilnehmen zu können, sowie die
          Datenschutzerklärung, deren Kenntnisnahme der Kunde bestätigen muss, per QR-Code zur Verfügung gestellt. Beide
          Dokumente liegen gemäß Ziffer 1.3 auch in Papierform beim Händler zur Einsichtnahme aus.
        </IndentedParagraph>
        <IndentedParagraph>
          1.6. Der Kunde wird außerdem gebeten, seine E-Mail-Adresse anzugeben, die als ausschließliches
          Kommunikationsmittel zwischen dem Händler und dem Kunden verwendet wird, zur Identifizierung des Kunden dient
          und mit dem Loyalty Programmkonto des Kunden verknüpft wird. Der Kunde ist nicht berechtigt, die
          E-Mail-Adresse einer anderen Person anzugeben.
        </IndentedParagraph>
        <IndentedParagraph>
          1.7. Der Kunde nimmt am Loyalty Programm teil, wenn er über das Zahlungsterminal die Bestätigung &quot;Nehmen
          Sie am Loyalty Programm teil und erhalten Sie Vorteile&quot; erhält.
        </IndentedParagraph>
        <IndentedParagraph>
          1.8. Nach der Teilnahme am Loyalty Programm erhält der Kunde eine Bestätigungs-E-Mail, in der diese
          Allgemeinen Geschäftsbedingungen und die Datenschutzerklärung über einen statischen Link wieder zugänglich
          gemacht werden. In der Bestätigungs-E-Mail wird der Kunde aufgefordert, seine Teilnahme am Loyalty Programm
          innerhalb von dreißig (30) Tagen zu bestätigen, indem er den Link in der E-Mail nutzt, um seine E-Mail-Adresse
          zu verifizieren und damit die Aktivierung seines Kontos im Rahmen des Loyalty Programms abzuschließen. Nach
          der Verifizierung der E-Mail-Adresse des Kunden wird das Konto des Kunden im Rahmen des Loyalty Programms
          aktiviert und der Kunde ist berechtigt, die gesammelten Treuepunkte gemäß den in Ziffer 3 dargelegten Regeln
          einzulösen.
        </IndentedParagraph>
        <IndentedParagraph>
          1.9. Wird die Teilnahme des Kunden am Loyalty Programm aus irgendeinem Grund nicht per E-Mail an die
          E-Mail-Adresse des Kunden bestätigt, ist der Kunde nicht berechtigt, die Treuepunkte zu nutzen. Bestätigt der
          Kunde seine Teilnahme am Loyalty Programm nicht innerhalb der in Artikel 1.8 genannten Frist, wird seine
          E-Mail-Adresse automatisch aus dem Loyalty Programm entfernt und seine Teilnahme am Loyalty Programm beendet.
          Bereits gesammelte Treuepunkte werden gelöscht. Bei einer neuen Zahlung an den Händler über das
          Zahlungsterminal kann der Kunde erneut zur Teilnahme am Loyalty Programm eingeladen werden.
        </IndentedParagraph>
        <IndentedParagraph>
          1.10. Es ist möglich, einem Kundenkonto mehrere Zahlungskarten zuzuordnen, indem man das oben beschriebene
          Verfahren anwendet (d.h. indem man die gleiche E-Mail-Adresse des Kunden eingibt, wenn man mit einer anderen
          Karte bezahlt).
        </IndentedParagraph>
        <IndentedParagraph>
          1.11. Die Teilnahme am Loyalty Programm ist kostenlos und verpflichtet nicht zum Kauf von Waren oder
          Dienstleistungen des Händlers.
        </IndentedParagraph>

        <TermsSubTitle>2. SAMMLUNG UND STATUS VON TREUEPUNKTEN</TermsSubTitle>

        <IndentedParagraph>
          2.1. Für jede Zahlung, die mit einer in Deutschland ausgestellten, von VISA oder Mastercard unterstützten
          Zahlungskarte auf ein im Rahmen des Loyalty Programms registriertes Konto einer nicht unternehmerisch tätigen
          Privatperson oder über die ELV-Zahlungsmethode auf ein im Rahmen des Loyalty Programms registriertes Konto
          einer nicht unternehmerisch tätigen Privatperson (jeweils: &quot;Registrierte Zahlungsmethode&quot;) am
          Zahlungsterminal des Händlers erfolgt, erhält der Kunde für jeden getätigten Einkauf von einem (1) EUR einen
          (1) Treuepunkt. Informationen über die Höhe der verdienten Treuepunkte werden bei jeder Zahlung am
          Zahlungsterminal angezeigt.
        </IndentedParagraph>

        <TermsSubTitle>3. EINLÖSEN VON TREUEPUNKTEN</TermsSubTitle>

        <IndentedParagraph>
          3.1. Bei Erreichen der {pointThreshhold || '[merchant-loyalty-points-threshold]'} an Treuepunkten werden die
          Treuepunkte in der angegebenen Höhe automatisch in eine Prämie in Höhe von{' '}
          {rewardAmount ? `${parseInt(rewardAmount) / 100} EUR` : '[merchant-loyalty-reward-amount]'} umgewandelt. Ab
          diesem Zeitpunkt kann der Kunde für einen Zeitraum von dreißig (30) Tagen eine Prämienauszahlung auf eine in
          Deutschland ausgegebene, von VISA oder Mastercard unterstützte Zahlungskarte oder über die ELV-Zahlungsmethode
          beantragen und sich im Rahmen des Loyalty Programms registrieren lassen.
        </IndentedParagraph>
        <IndentedParagraph>
          3.2. Bei Erreichen der Treuepunkteschwelle wird dem Kunden am Zahlungsterminal des Händlers angezeigt, dass er
          bei Zahlung mit einer in Deutschland ausgestellten, von VISA oder Mastercard unterstützten Zahlungskarte oder
          über die Zahlungsmethode ELV, die im Rahmen des Loyalty Programms registriert ist, Anspruch auf eine
          Prämienzahlung hat. Die Auszahlung der Prämie kann über das Zahlungsterminal bestätigt werden und erfolgt dann
          automatisch innerhalb von achtundvierzig (48) Stunden nach der Bestätigung; der Händler behält sich jedoch das
          Recht vor, diese Frist zu verlängern, wenn unvorhergesehene Umstände (einschließlich technischer Störungen)
          eintreten, die die Auszahlung der Prämie innerhalb der vorgenannten Frist verhindern würden. Die Auszahlung
          der Prämie erfolgt über Mastercard MoneySend, Visa Direct oder eine SEPA-Überweisung im Falle von ELV. Die
          Bank, die die registrierte Zahlungsmethode, auf die die Prämie ausgezahlt werden soll, ausgegeben hat, kann
          für diese Art von Transaktion eine Gebühr gemäß den Geschäftsbedingungen der jeweiligen Bank erheben.
        </IndentedParagraph>
        <IndentedParagraph>
          3.3. Die Menge der Treuepunkte, die für Zahlungen mit der im Rahmen des Loyalty Programms registrierten
          Zahlungskarte des Kunden angesammelt wurden, wird nicht verringert, wenn der Händler Geldbeträge auf die
          registrierte Zahlungsmethode des Kunden zurücküberweist (aufgrund der Ausführung der Transaktion „Rückgabe“
          und „Stornierung“ durch den Händler). Die gesammelten Treuepunkte werden nach dreihundertfünfundsechzig (365)
          Tagen ab dem Datum ihrer Gutschrift im Rahmen des Loyalty Programms schrittweise gelöscht (sofern sie nicht
          zuvor in eine Prämie umgewandelt wurden). Gemäß Abschnitt 3.1 dieser Allgemeinen Geschäftsbedingungen wird
          eine Prämie dreißig (30) Tage nach dem Datum, an dem sie erstmals hätte eingelöst werden können, gelöscht.
        </IndentedParagraph>

        <TermsSubTitle>4. BEENDIGUNG DER TEILNAHME AN DEM LOYALTY PROGRAMM</TermsSubTitle>

        <IndentedParagraph>
          4.1. Wenn der Kunde nicht mit der Teilnahme am Loyalty Programm einverstanden ist, kann er über den in der
          Bestätigungs-E-Mail enthaltenen Link &quot;Abmeldung vom Loyalty Programm&quot; gemäß Klausel 1.8 aus dem
          Loyalty Programm aussteigen.
        </IndentedParagraph>
        <IndentedParagraph>
          4.2. Falls der Kunde seine Teilnahme am Loyalty Programm jederzeit beenden möchte, nachdem er seine
          E-Mail-Adresse bestätigt und sein Konto im Loyalty Programm aktiviert hat, kann er dies über den Link
          „Abmeldung vom Loyalty Programm“ in der Fußzeile jeder vom Händler erhaltenen E-Mail tun. Wenn der Kunde auf
          den Link klickt, wird er auf eine Website weitergeleitet, auf der er seine Abmeldung vom Loyalty Programm
          bestätigt, wodurch die Teilnahme des Kunden am Loyalty Programm beendet wird. Im Falle der Beendigung der
          Teilnahme am Loyalty Programm verliert der Kunde alle Treuepunkte und Vorteile, die mit der Teilnahme am
          Loyalty Programm verbunden sind, und die Daten des Kunden werden unverzüglich aus dem System entfernt.
        </IndentedParagraph>
        <IndentedParagraph>
          4.3. Der Kunde kann seine Teilnahme am Loyalty Programm auch jederzeit fristlos kündigen, indem er eine
          schriftliche Mitteilung an den Händler unter den oben genannten Kontaktdaten (per Post oder E-Mail) schickt.
          In dieser Mitteilung muss der Kunde seine E-Mail-Adresse angeben, mit der sein Loyalty Programm-Konto
          verknüpft ist. Die Beendigung der Teilnahme am Loyalty Programm wird mit der Zustellung der Mitteilung an den
          Händler wirksam. Der Händler schickt dem Kunden eine E-Mail, in der er die Beendigung der Teilnahme des Kunden
          am Loyalty Programm bestätigt.
        </IndentedParagraph>
        <IndentedParagraph>
          4.4. Bei einer Neuanmeldung für das Loyalty Programm fallen keine Vorteile aus der vorherigen Teilnahme des
          Kunden an.
        </IndentedParagraph>
        <IndentedParagraph>
          4.5. Der Händler kann das Konto des Kunden im Falle eines Verstoßes gegen diese Allgemeinen
          Geschäftsbedingungen mit einer Frist von sechzig (60) Tagen kündigen.
        </IndentedParagraph>
        <IndentedParagraph>
          4.6. Weitere Gründe für die Beendigung des Loyalty Programms sind in den Ziffern 5.5 und 5.6 dieser
          Allgemeinen Geschäftsbedingungen aufgeführt.
        </IndentedParagraph>

        <TermsSubTitle>5. ANDERE</TermsSubTitle>

        <IndentedParagraph>
          5.1. Diese Allgemeinen Geschäftsbedingungen unterliegen dem deutschen Recht.
        </IndentedParagraph>
        <IndentedParagraph>
          5.2. Der Händler und der Kunde werden versuchen, alle Streitigkeiten, die sich aus diesen Bedingungen ergeben,
          einvernehmlich zu lösen.
        </IndentedParagraph>
        <IndentedParagraph>
          5.3. Kommt es im Rahmen eines Kauf-oder Dienstleistungsvertrags zu einer verbraucherrechtlichen Streitigkeit
          zwischen dem Händler und dem Kunden, der Verbraucher ist, die nicht einvernehmlich gelöst werden kann, kann
          der Kunde die Plattform zur Online-Streitbeilegung (OS) nutzen, die unter{' '}
          <a href="http://ec.europa.eu/odr">http://ec.europa.eu/odr</a> zur Verfügung steht, oder als Verbraucher einen
          Vorschlag zur außergerichtlichen Beilegung einer solchen Streitigkeit bei der benannten
          Verbraucherschlichtungsstelle einreichen:
        </IndentedParagraph>
        <TermsPlainText>Außergerichtliche Streitbeilegungsstelle für Verbraucher und Unternehmer e.V.</TermsPlainText>
        <TermsPlainText>Gohliser Str.6</TermsPlainText>
        <TermsPlainText>04105 Leizpzig</TermsPlainText>
        <TermsPlainText></TermsPlainText>
        <TermsPlainText>E-Mail: info@streitbeilegungsstelle.org</TermsPlainText>
        <TermsPlainText>Website: www.streitbeilegungsstelle.org</TermsPlainText>
        <IndentedParagraph>
          5.4. Die Firma GP Payments Acquiring International GmbH mit der Geschäftsadresse Elsa-Brandström-Straße 10-12,
          50668 Köln, Deutschland, eingetragen im Handelsregister des Amtsgerichts Köln unter HRB 78863 („Global
          Payments“) stellt die technische Lösung zur Verfügung, über die der VP das Loyalty Programm betreibt.
        </IndentedParagraph>
        <IndentedParagraph>
          5.5. Der Händler behält sich das Recht vor, das Loyalty Programm mit einer Frist von dreißig (30) Tagen zu
          kündigen, zu modifizieren oder zu ändern, und zwar im Falle einer Gesetzesänderung (einschließlich solcher
          Änderungen, die sich auf das Geschäft von Global Payments gemäß Artikel 5.4 beziehen), ohne eine solche
          Kündigung zu beachten.
        </IndentedParagraph>
        <IndentedParagraph>
          5.6. Wird die Bereitstellung der technischen Lösung, über die der Händler das Loyalty Programm betreibt, von
          Global Payments aus Gründen, die der Händler nicht zu vertreten hat, oder wegen eines wesentlichen Verstoßes
          gegen die zwischen Global Payments und dem Händler vereinbarten Bedingungen fristlos gekündigt, ist der
          Händler berechtigt, das Loyalty Programm mit sofortiger Wirkung zu kündigen. In einem solchen Fall verliert
          der Kunde alle Treuepunkte und Vorteile, die mit der Teilnahme am Loyalty Programm verbunden sind.
        </IndentedParagraph>
        <IndentedParagraph>
          5.7. Der Händler behält sich ferner das Recht vor, diese AGB zu ändern oder zu ergänzen, insbesondere wenn
          dies im Interesse der Einfachheit und zur Gewährleistung einer sicheren Verarbeitung von personenbezogenen
          Daten und Treuepunkten und/oder zur Verhinderung von Missbrauch des Systems erforderlich ist. Die Änderung der
          Allgemeinen Geschäftsbedingungen wird dem Kunden im Voraus per E-Mail mitgeteilt. Sollte der Kunde mit der
          Änderung nicht einverstanden sein, hat er das Recht, seine Teilnahme am Loyalty Programm mit sofortiger
          Wirkung vor dem Datum des Inkrafttretens der betreffenden Änderungen zu beenden.
        </IndentedParagraph>
        <Footer>Aktualisiert am {formattedActivationDate}</Footer>
      </TermsPlainTextWrapper>
    </TermsTextWrapper>
  );
};
